import { className } from '@empori/util';
import * as React from 'react';
import { useSwiper } from 'swiper/react';
export function CaseStudySlide(props) {
    var item = props.item, translations = props.translations;
    return (React.createElement("a", { href: item.linkUrl, className: className('case-study-slide-item element-flex', { active: true }), style: { background: '#393939' } },
        item.imgPathSlides && (React.createElement("img", { className: "list-background-image", src: item.imgPathSlides, width: "400", height: "470", alt: props.item.title, loading: 'lazy' })),
        React.createElement("div", { className: "case-study-slide-item-content" },
            item.company && React.createElement("h5", { className: 'bullet-subheader' }, item.company),
            item.title && (React.createElement("h3", null, item.title)),
            item.description && (React.createElement("p", { className: 'case-study-description' }, item.description.length > 150
                ? "".concat(item.description.slice(0, item.description.lastIndexOf(' ', 150)), "...")
                : item.description)),
            item.linkUrl && (React.createElement("span", { className: 'text-like' }, translations.readMoreLabel)))));
}
export function SwiperArrow(props) {
    var swiper = useSwiper();
    if (props.totalSlides <= 1) {
        return null;
    }
    return (React.createElement("div", { className: className("swiper-arrow swiper-".concat(props.direction), {
            disabled: props.activeIndex === 0
        }), onClick: function () {
            if (props.direction === 'left') {
                swiper.slidePrev();
                return;
            }
            swiper.slideNext();
        } },
        React.createElement("div", { className: "empori-slideshow-navigation-item ".concat(props.direction) },
            props.direction === 'left' &&
                React.createElement("img", { src: "/images/Arrow-left.svg", alt: "Navigate to the left", loading: 'lazy' }),
            props.direction === 'right' &&
                React.createElement("img", { src: "/images/Arrow-right.svg", alt: "Navigate to the right", loading: 'lazy' }))));
}
